// Atalhos de teclado, no padrão que quem usa Gmail já conhece.
//
// A regra que evita o defeito clássico: NENHUM atalho dispara enquanto o foco
// está num campo de texto. Sem isso, escrever "compre" numa mensagem abriria a
// janela de escrita no "c" e arquivaria no "e".

import { useEffect } from "react";

export interface Atalhos {
  escrever?: () => void;
  voltar?: () => void;
  arquivar?: () => void;
  excluir?: () => void;
  responder?: () => void;
  encaminhar?: () => void;
  atualizar?: () => void;
}

export function digitandoEm(alvo: EventTarget | null): boolean {
  const e = alvo as HTMLElement | null;
  if (!e) return false;
  return (
    e.tagName === "INPUT" ||
    e.tagName === "TEXTAREA" ||
    e.tagName === "SELECT" ||
    e.isContentEditable === true
  );
}

export function useAtalhos(atalhos: Atalhos, ativo = true) {
  useEffect(() => {
    if (!ativo) return;

    function aoTeclar(e: KeyboardEvent) {
      // Combinações do sistema continuam sendo do sistema: Ctrl+R recarrega,
      // Cmd+C copia. Um webmail que sequestra isso é um webmail que irrita.
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (digitandoEm(e.target)) return;

      const acao: (() => void) | undefined = {
        c: atalhos.escrever,
        u: atalhos.voltar,
        e: atalhos.arquivar,
        "#": atalhos.excluir,
        r: atalhos.responder,
        f: atalhos.encaminhar,
        Escape: atalhos.voltar,
      }[e.key];

      if (acao) {
        e.preventDefault();
        acao();
      }
    }

    window.addEventListener("keydown", aoTeclar);
    return () => window.removeEventListener("keydown", aoTeclar);
  }, [atalhos, ativo]);
}

/** O que a tela de ajuda mostra. Uma fonte só, para não divergir do código. */
export const TABELA_DE_ATALHOS: [string, string][] = [
  ["c", "Escrever"],
  ["/", "Pesquisar"],
  ["r", "Responder"],
  ["f", "Encaminhar"],
  ["e", "Arquivar"],
  ["#", "Excluir"],
  ["u", "Voltar para a lista"],
];
